import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {
    Container,
    CssBaseline,
} from '@material-ui/core';
import {
    Check,
    Clear,
    SaveAlt,
    FilterList,
    FirstPage,
    LastPage,
    ChevronRight,
    ChevronLeft,
    Search,
    Remove,
    ViewColumn,
} from '@material-ui/icons';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import DeleteIcon from '@material-ui/icons/Delete';
import MaterialTable from 'material-table';
import Loading from '../components/Loading';
import Nav from '../components/NavBar/Nav';

import api from '../services/Api';
import Toast from '../components/Toast';

class Users extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            token: '',
            drawer: false,
            loading: false,
            columns: [
                {title: 'Id', field: 'id'},
                {title: 'Nome', field: 'name'},
                {title: 'Email', field: 'email'},
                {title: 'Celular', field: 'cel_phone'},
                {title: 'Estado', field: 'state'},
                {title: 'Cidade', field: 'city'},
            ],
            data: [
                {
                    id: '1',
                    name: 'Usuário 1',
                    email: 'usuario1@mail.com',
                    cel_phone: '(00) 90000-0000',
                    state: 'XX',
                    city: 'Cidade 1',
                },
                {
                    id: '2',
                    name: 'Usuário 2',
                    email: 'usuario2@mail.com',
                    cel_phone: '(00) 90000-0000',
                    state: 'XX',
                    city: 'Cidade 2',
                },
                {
                    id: '3',
                    name: 'Usuário 3',
                    email: 'usuario3@mail.com',
                    cel_phone: '(00) 90000-0000',
                    state: 'XX',
                    city: 'Cidade 3',
                },
                {
                    id: '4',
                    name: 'Usuário 4',
                    email: 'usuario4@mail.com',
                    cel_phone: '(00) 90000-0000',
                    state: 'XX',
                    city: 'Cidade 4',
                },
            ]
        };
    }

    componentDidMount() {

        this.setState({ loading: true });

        const token = localStorage.getItem('TOKEN_KEY');

        api.post("/admin/check", { }, { headers: { Authorization: 'Bearer ' + token }})
        .then(
            res => {
                if(res.data.status){
                    setTimeout(() => this.setState({ loading: false }), 1000);                 
                }

                if(!res.data.status){
                    setTimeout(() => this.setState({ loading: false }), 1000);                
                }
            }
        ).catch(err => {
            console.log(err);
        })     
    }

    openDrawer = () => {
        this.setState({drawer: !this.state.drawer})
    }

    render() {

        if(this.state.loading) {
            return <Loading />;           
        }

        return (
            <div className={styles.root}>
                <CssBaseline/>
                <Nav />

                <Container maxWidth="lg" style={users.table}>
                    <MaterialTable
                        icons={{
                            Check: () => <Check/>,
                            Clear: () => <Clear/>,
                            Export: () => <SaveAlt/>,
                            Filter: () => <FilterList/>,
                            FirstPage: () => <FirstPage/>,
                            LastPage: () => <LastPage/>,
                            NextPage: () => <ChevronRight/>,
                            PreviousPage: () => <ChevronLeft/>,
                            Search: () => <Search/>,
                            ResetSearch: () => <Clear/>,
                            ThirdStateCheck: () => <Remove/>,
                            ViewColumn: () => <ViewColumn/>,
                            DetailPanel: () => <ChevronRight/>
                        }}
                        title="Usuários"
                        columns={this.state.columns}
                        data={this.state.data}
                        actions={[
                            {
                              icon: () => <RemoveRedEyeIcon/>,
                              tooltip: 'Visualizar',
                              onClick: (event, rowData) => alert("Visualizar informações de " + rowData.name)
                            },
                            rowData => ({
                              icon: () => <DeleteIcon/>,
                              tooltip: 'Deletar Usuário',
                              onClick: (event, rowData) => alert("Você deletou o " + rowData.name),
                              disabled: rowData.birthYear < 2000
                            })
                          ]}
                          options={{
                            actionsColumnIndex: -1
                          }}
                    />
                </Container>

            </div>
        )
    }

}

const users = {

    table: {
        marginTop: 50,
        marginBottom: 20
    },

}

const styles = {
    root: {
        display: 'flex',
    },
    drawer: {
        width: 'auto',
    },
    list: {
        width: 250,
    },
}

export default withStyles(styles)(Users);
